/* eslint-disable import/default */
import "babel-polyfill";
import React from "react";
import { render } from "react-dom";
import { Provider } from "react-redux";
import { ThemeProvider } from "@material-ui/styles";
import theme from "./theme";
import DialogProvider from "components/Shared/DialogProvider.tsx";
import WebConfig from "./middlewares/WebConfig";
import { PhoenixFormsProvider } from "components/PhoenixFormsV4/index.tsx";
import QuickFilterProvider from "components/QuickLists/QuickFilterProvider.tsx";

// CSS and other assets
require("./favicon.ico"); // Tell webpack to load favicon.ico
import "mueller-controls/dist/src/mueller-controls.css";
import "styles/styles.scss";
if (WebConfig.rootStylesheet) {
  //This switch layer is required to proxy the values in the webconfig as import paths can not be a variable or the result of string interpolation
  switch (WebConfig.rootStylesheet) {
    case ("./environment/non-prod-styles.scss"): {
      import("./environment/non-prod-styles.scss");
    }
  }
}

// local components
import App from "containers/App";
import configureStore from "store/configureStore";
import { createBrowserHistory } from "history";
import BrowserWarning from "components/Shared/BrowserWarning";
import CacheBuster from "components/Shared/CacheBuster";
import AppInsightsInit from "middlewares/AppInsightsInit";
import TooltipProvider from "components/Shared/TooltipProvider.tsx";
import MuellerThemeProvider from "components/Shared/MuellerThemeProvider.tsx";
import WindowProvider from "components/Shared/WindowProvider.tsx";
AppInsightsInit.init();

const baseName = (location.hostname === "localhost" || location.hostname === "dev-webui.mueller-inc.com") ? "/" : "/webui";
const history = createBrowserHistory({ basename: baseName });
const { persistor, store } = configureStore(history);

// exporting store to allow access to dispatch and state from outside a react component
// must export store before rendering, some parts of the system make web calls instantly when render is called, and then store isnt exported yet
export default store;

render(
  <div>
    <BrowserWarning />
    <Provider store={store}>
      <MuellerThemeProvider>
        <ThemeProvider {...{ theme }}>
          <WindowProvider>
            <DialogProvider>
              <TooltipProvider>
                <PhoenixFormsProvider>
                  <QuickFilterProvider>
                    <CacheBuster/>
                    <App history={history} persistor={persistor} />
                  </QuickFilterProvider>
                </PhoenixFormsProvider>
              </TooltipProvider>
            </DialogProvider>
          </WindowProvider>
        </ThemeProvider>
      </MuellerThemeProvider>
    </Provider>
  </div>,
  document.getElementById("app")
);
